import { Snackbar, Alert } from "@mui/material";
import { useBszPlannerContext } from "../../context/bszPlannerContext";

export default function BSZPlannerAlerts({ actions }) {
  const { snackbar } = useBszPlannerContext();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={actions.handleCloseSnackbar}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Alert
        onClose={actions.handleCloseSnackbar}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
